import { CardBody } from "reactstrap";
import { CommonTagCardBodyProp } from "../../../../Type/CommonComponant";

const CommomTagAndPillsCardBody = ({ data, number }: CommonTagCardBodyProp) => {
  return (
    <CardBody>
      <div className="badge-spacing">
        <>
          {data &&
            data.map(({ className, text}, index) => (
              <span className={`badge ${className}`} key={index}>
                {text}
              </span>
            ))}
          {number &&
            number.map(({ className, text,icon }, index) => (
              <a href="#javascript" className={`badge ${className}`} key={index}>
                {text && text} {icon && icon}
              </a>
            ))}
        </>
      </div>
    </CardBody>
  );
};

export default CommomTagAndPillsCardBody;
